import { useState } from 'react';
import api from '../services/api';
import SEO from '../components/SEO';

const ResetPasswordPage = ({ token, switchToLogin }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    setError('');
    setStatus('');
    try {
      const res = await api.post('/auth/reset-password', { token, password });
      setStatus(res.data.message);
      setTimeout(() => switchToLogin(), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <SEO title="Reset Password" description="Create a new password for your Study Centro account." />
      <div className="auth-card">
        <h1>Reset Password</h1>
        <p>Enter your new password below.</p>
        
        {status && <div className="status-message">{status} - Redirecting to login...</div>}
        {error && <div className="error-message">{error}</div>}

        {!status && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                minLength={6}
              />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="••••••••"
                minLength={6}
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        )}
        <div className="auth-footer">
          <button onClick={switchToLogin} className="link-button">Back to Login</button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
